import { ECBO_FF_COOKIE_NAME } from './constants'
import { deserializeFlagsFromCookieValue } from './cookie'
import type { EcboFeatureFlags } from './parse'

/**
 * ブラウザのみ。document.cookie から Middleware が載せたフラグ JSON を読む。
 */
export function readEcboFeatureFlagsFromDocument(): EcboFeatureFlags {
  if (typeof document === 'undefined') return {}
  const prefix = `${ECBO_FF_COOKIE_NAME}=`
  const segments = document.cookie.split('; ')
  for (const segment of segments) {
    if (segment.startsWith(prefix)) {
      return deserializeFlagsFromCookieValue(segment.slice(prefix.length))
    }
  }
  return {}
}
